import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React, { useState, useEffect, useRef } from 'react';
import DefaultTheme from './theme';
export var TextAreaTheme = DefaultTheme;
/*::
import type { TextAreaThemeType } from './theme';

type Props = {|
  className?: string;
  value?: string,
  onChange?: (value: string) => void,
  disabled?: boolean;
  error?: boolean;
  readOnly?: boolean;
  onFocus?: (e: FocusEvent) => void;
  onBlur?: (e: FocusEvent) => void;
  theme?: TextAreaThemeType;
  rest?: any,
|}
*/

var TextArea = function TextArea(_ref
/*: Props */
) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return undefined;
  } : _ref$onChange,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? function () {
    return undefined;
  } : _ref$onFocus,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {
    return undefined;
  } : _ref$onBlur,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["value", "onChange", "onFocus", "onBlur", "className", "theme"]);

  var textAreaRef = useRef(null);

  var _useState = useState('auto'),
      textAreaHeight = _useState[0],
      setTextAreaHeight = _useState[1];

  var _useState2 = useState('auto'),
      parentHeight = _useState2[0],
      setParentHeight = _useState2[1];

  useEffect(function () {
    if (textAreaRef && textAreaRef.current) {
      setParentHeight(textAreaRef.current.scrollHeight + "px");
    } // Flow bug: typeguard only works for 1st line


    if (textAreaRef && textAreaRef.current) {
      setTextAreaHeight(textAreaRef.current.scrollHeight + "px");
    }
  }, [value]);

  var onChangeHandler = function onChangeHandler(event) {
    if (textAreaRef && textAreaRef.current) {
      setParentHeight("\n      " + textAreaRef.current
      /*: HTMLTextAreaElement */
      .scrollHeight + "px");
      setTextAreaHeight('auto');
    }

    onChange(event.target.value);
  };

  return /*#__PURE__*/React.createElement(theme.Main, {
    className: className,
    styledHeight: parentHeight
  }, /*#__PURE__*/React.createElement(theme.TextArea, Object.assign({
    ref: textAreaRef,
    value: value,
    onChange: onChangeHandler,
    onFocus: onFocus,
    onBlur: onBlur,
    rows: 1,
    styledHeight: textAreaHeight,
    "data-test": "textarea"
  }, rest)));
};

export default TextArea;